export default "__VITE_ASSET__7b2c05af__"